import { MainContainer, TitleAndActionBox } from "../../../../common";
import { Box, Grid } from "@mui/material";
import { UBButton } from "../../../../../Libraries";
import { useContext, useEffect, useState } from "react";
import { LanguageContext } from "../../../../../context/LanguageContext";
import styles from "./styles.module.css";
import "../../../../Features/NewStockBook/styles.module.css";
import withObservables from "@nozbe/with-observables";
import { useStockProfit } from "../../../../../hooks/useStockProfit";
import StockHistory from "./StockHistory";
import { useNavigate } from "react-router-dom";
import StockInOutModal from "../../StockInOutModal";
import { observeStockByID } from "../../../../../database/helpers/stock";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import StockCard from "../../../../common/StockCard";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { ITEMS_PER_PAGE, sentenceCase } from "../../../../../constants";

const ItemReport = ({ product, stockId }) => {
  product = product.length ? product[0] : product;
  const [showStockInModal, setShowStockInModal] = useState(false);
  const [page, setPage] = useState(0);
  const [list, setList] = useState([]);
  const [filters, setFilters] = useState({
    startDate: null,
    endDate: null,
  });
  const [selectedDate, setSelectedDate] = useState(null)

  const navigate = useNavigate();
  const { totalIn, outCount, totalSalePrice, handleStockProfit,handleFilterProfitTracker } =
    useStockProfit(product, "All time");

  useEffect(() => {
    triggerLogEvent(analytics, "sb_item_detail");
  }, []);

  useEffect(() => {
    setList([]);
  }, []);

  const handleGetInitialData = () => {
    setPage(0);
    handleStockProfit({
      limit: ITEMS_PER_PAGE,
      offset: 0,
    });
  };

  useEffect(() => {
    handleGetInitialData();
  }, []);

  const handleApplyFilter = (startDate, endDate, label) => {
    setSelectedDate(startDate ? { start: startDate, end: endDate, label: label || "" } : null);
    handleFilterProfitTracker(startDate, endDate);
  };

  const [I18n] = useContext(LanguageContext);
  return (
    <MainContainer fluid>
      <Grid container>
        <Grid item md={12}>
          <TitleAndActionBox
            data={{
              title: product?.name || "",
              isBack: true,
              id: "stockItemReport",
              isEdit: true,
              onEdit: () => {
                triggerLogEvent(analytics, "sb_edit_button");
                navigate(`/Inventory/Edit/${stockId}`);
              },
            }}
          >
            <UBButton
              id={`stockItemReport_in/out_btn`}
              title={I18n.stock_in_out}
              onClick={() => setShowStockInModal(true)}
              className={"ubSecondaryButton marginLeft15 stockInOutButton"}
            />
          </TitleAndActionBox>

          <Grid container spacing={2}>
            <Grid item md={6} className={styles.stockCardWrapper}>
              <StockCard
                titleAmount={product?.selling_price}
                subHeading={I18n.selling_price}
                firstHeading={{
                  title: I18n.cost_price,
                  value: `Rs. ${formatNum(product?.cost_price)}`,
                }}
                secondHeading={{
                  title: I18n.available_stock,
                  value: product?.stock?.toString()?.includes(".")
                    ? Number(product?.stock).toFixed(2)
                    : product?.stock || 0,
                }}
                thirdHeading={{
                  title: I18n.stock_value,
                  value: `Rs. ${formatNum(Number(product?.stock || 0) * Number(product?.selling_price || 0))}`,
                }}
              />
            </Grid>

            <Grid item md={6}>
              
              <StockCard
                title={sentenceCase(I18n.profile_tracker)}
                titleAmount={totalIn || 0}
                subHeading={I18n.profit}
                firstHeading={{
                  title: I18n.units_sold,
                  value: outCount,
                }}
                secondHeading={{
                  title: I18n.total_cost,
                  value: `Rs. ${formatNum((product?.cost_price || 0) * outCount)}`,
                }}
                thirdHeading={{
                  title: I18n.total_sales,
                  value: `Rs. ${formatNum(totalSalePrice)}`,
                }}
                showRangePicker={true}
                selectedDate={selectedDate}
                handleFilterDate={handleApplyFilter}
              />
            </Grid>
          </Grid>
          <StockHistory
            product={product}
            page={page}
            setPage={setPage}
            ITEMS_PER_PAGE={ITEMS_PER_PAGE}
            list={list}
            setList={setList}
            handleStockProfit={handleStockProfit}
          />
        </Grid>
      </Grid>

      {showStockInModal && (
        <StockInOutModal
          showStockInModal={showStockInModal}
          setShowStockInModal={setShowStockInModal}
          item={product}
          handleSuccessCallBack={() => {
            handleGetInitialData();
          }}
        />
      )}
    </MainContainer>
  );
};

const enhance = withObservables(["stockId"], ({ stockId }) => ({
  product: observeStockByID(stockId),
}));
export default enhance(ItemReport);
